import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {MsalService} from "@azure/msal-angular";
import {catchError, switchMap, throwError, zip} from "rxjs";

import Swal from "sweetalert2";

import {RegistrationService, CityService, MessageService, AuthService} from "@services";
import {AppBaseComponent} from "@utils";

@Component({
  selector: 'app-natural-person-profile',
  templateUrl: './natural-person-profile.component.html',
  styleUrls: ['./natural-person-profile.component.scss']
})
export class NaturalPersonProfileComponent extends AppBaseComponent implements OnInit {

  naturalForm: FormGroup

  sending: boolean = false;

  public departaments: any[] = [];
  public municipios: any[] = [];
  public paiss: any[] = [];
  public sexoo: any[] = [];
  public generoo: any[] = [];
  public orientacionn: any[] = [];
  public etniaa: any[] = [];
  public estadoCivill: any[] = [];
  public nivelEducativoo: any[] = [];
  public tipoIdentificacionn: any[] = [];

  constructor(public fb: FormBuilder,
              public registrationService: RegistrationService,
              public cityService: CityService,
              private popupAlert: MessageService,
              private router: Router,
              private msalAuthService: MsalService,
              private authService: AuthService) {
    super();
  }

  ngOnInit(): void {
    this.naturalForm = this.fb.group({

      tipoDocumento: ['', [Validators.required]],
      numeroIdentificacion: ['', [Validators.required]],
      primerNombre: ['', [Validators.required]],
      segundoNombre: [''],
      primerApellido: ['', [Validators.required]],
      segundoApellido: [''],
      email: ['', [Validators.required, Validators.email]],
      confirmarEmail: ['', [Validators.required, Validators.email]],
      telefonoFijo: ['', [Validators.minLength(7), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]],
      telefonoCelular: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]],
      nacionalidad: ['', [Validators.required]],
      departamento: [''],
      ciudadNacimiento: [''],
      ciudadNacimientoOtro: [''],
      departamentoResidencia: ['', [Validators.required]],
      ciudadResidencia: ['', [Validators.required]],
      direccionResidencia: ['', [Validators.required]],
      fechaNacimiento: ['', [Validators.required, super.dateValidator]],
      sexo: ['', [Validators.required]],
      genero: ['', [Validators.required]],
      orientacionSexual: ['', [Validators.required]],
      etnia: ['', [Validators.required]],
      estadoCivil: ['', [Validators.required]],
      nivelEducativo: ['', [Validators.required]],
      cx: [1],
      cy: [1],
      upz: [1],
      zona: [1],
      localidad: [1],
      barrio: ["barrio"],
      checkBoxDatosPersonales: ['', [Validators.required, Validators.requiredTrue]]
    })

    zip(
      this.registrationService.getPais(),
      this.cityService.getDepartaments(),
      this.registrationService.getSexo(),
      this.registrationService.getGenero(),
      this.registrationService.getOrientacion(),
      this.registrationService.getEtnia(),
      this.registrationService.getEstadoCivil(),
      this.registrationService.getNivelEducativo(),
      this.registrationService.getTipoIdentificacion()
    ).subscribe(resp => {
      this.paiss = resp[0].data;
      this.departaments = resp[1].data;
      this.sexoo = resp[2].data;
      this.generoo = resp[3].data;
      this.orientacionn = resp[4].data;
      this.etniaa = resp[5].data;
      this.estadoCivill = resp[6].data;
      this.nivelEducativoo = resp[7].data;
      this.tipoIdentificacionn = resp[8].data;
    });

    if (this.naturalForm.get('departamentoResidencia').value != "") {
      this.cityService.getMunByDepaId(this.naturalForm.get('departamentoResidencia').value).subscribe(resp => {
        this.municipios = resp.data
      });
    }
  }

  getMunicipios(idDep: number): void {
    this.cityService
      .getMunByDepaId(idDep)
      .subscribe(resp => this.municipios = resp.data);
  }

  regresar(): void {
    this.router.navigateByUrl('/').then(resp => location.reload());
  }

  cuerpoEmail(fullName, numeroIdentificacion) {
    let bodyEmail = "Respetado(a) Ciudadano(a)," + fullName + "<br>" +
      "<br>" +
      "¡Gracias por registrarse! <br>" +
      "<br>" +
      "Puede acceder a la plataforma a través del siguiente enlace <a href='https://lemon-smoke-06942be0f-dev.eastus2.2.azurestaticapps.net'> Tramites</a> <br>" +
      "<br>" +
      "Ante cualquier inquietud puede consultar la información dispuesta en el portal de la Ventanilla Única de Trámites y Servicios o a través del correo contactenos@saludcapital.gov.co <br>" +
      "<br>" +
      "Cordialmente,<br>" +
      "<br>" +
      "SECRETARIA DISTRITAL DE SALUD<br>" +
      "<a href='https://lemon-smoke-06942be0f-dev.eastus2.2.azurestaticapps.net'> Tramites</a> <br>" +
      "KR 32 No. 12 - 81<br>" +
      "Teléfono (601)3649090<br>" +
      "<img src='https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.colnodo.apc.org%2Fes%2Forganizaciones-aliadas%2Fsecretaria-distrital-de-salud&psig=AOvVaw3nV8X82K0RbU_RliXnBHdI&ust=1674671289741000&source=images&cd=vfe&ved=0CBAQjRxqFwoTCJD6-e7q4PwCFQAAAAAdAAAAABAD'>"
    return bodyEmail;
  }


  async SaveNaturalPerson() {

    if (this.naturalForm.get('email').value != this.naturalForm.get('confirmarEmail').value) {
      this.popupAlert.errorAlert(
        `Por favor, revise el formulario de la solicitud, los emails ingresados no son iguales.`,
        4000
      );
      return;
    }

    if (!this.naturalForm.valid) {
      this.popupAlert.errorAlert(
        `Por favor, revise el formulario de la solicitud, hay datos invalidos y/o incompletos.`,
        4000
      );
      this.naturalForm.markAllAsTouched();
      return;
    }

    this.sending = true;

    this.popupAlert.infoAlert(
      `<b>Registrando usuario...</b> Puede tardar un poco, no actualice o recarge la página, un momento por favor`,
      10000
    );

    this.naturalForm.get('departamento').setValue(this.naturalForm.get('departamentoResidencia').value);
    this.naturalForm.get('ciudadNacimiento').setValue(this.naturalForm.get('ciudadResidencia').value);
    const formData = this.naturalForm.value;
    const oidToken = this.authService.getLoggedUser().oid;
    let requestToSave = {...formData};

    let idCodeVentanilla: any;
    let personaRegistrada: any;

    this.registrationService.saveNaturalPerson(requestToSave).pipe(
      switchMap(resp1 => {
        idCodeVentanilla = resp1.data;
        return this.registrationService.getInfoUserByIdCodeVentanilla(idCodeVentanilla)
      }),
      switchMap(resp2 => {
        personaRegistrada = resp2.data;
        let dataPersonaAddUser = {
          "oid": oidToken,
          "email": personaRegistrada.email
        }
        return this.registrationService.addUserToSecurityAPI(dataPersonaAddUser)
      }),
      switchMap(resp3 => {
        let dataPersonaUpdateUser = {
          "oid": oidToken,
          "email": personaRegistrada.email,
          "nombreCompleto": personaRegistrada.fullName,
          "created": new Date(Date.now()),
          "idPersonaVentanilla": idCodeVentanilla,
          "isEnabled": true
        }
        return this.registrationService.updateUser(dataPersonaUpdateUser)
      }),
      switchMap(resp4 => {
        let bodyEmail = this.cuerpoEmail(personaRegistrada.fullname, personaRegistrada.numeroIdentificacion);

        let cuerpoEmail = {
          "to": personaRegistrada.email,
          "subject": "Activación cuenta Ventanilla Única de Trámites y Servicios Secretaría Distrital de Salud",
          "body": bodyEmail
        }
        return this.registrationService.sendEmail(cuerpoEmail)
      }),
      catchError(error => {
        this.sending = false;
        this.popupAlert.errorAlert('Ocurrió un error al registrarse.', 4000);
        return throwError(() => new Error(error.message));
      })
    ).subscribe({
      next: resp5 => {
        this.popupAlert.successAlert('¡Su registro se ha realizado satisfactoriamente!', 4000);

        Swal.fire({
          icon: 'success',
          title: 'Registro existoso',
          confirmButtonColor: '#0000FF',
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: 'OK',
          text: 'Será redigirido a la página principal y deberá iniciar sesión nuevamente para acceder a los servicios.',
        }).then((result) => {
          this.msalAuthService.logoutPopup({
            mainWindowRedirectUri: "/"
          }).subscribe(resp => {
            this.popupAlert.infoAlert("¡Sesión cerrada exitosamente!", 4000);
            localStorage.clear();
            this.authService.setCurrentUser(null);
          });
        });
      },
      error: err => {
        this.sending = false;
        this.popupAlert.errorAlert('Ocurrió un error al registrarse.', 4000);
      }
    });
  }

  verificarFecha() {
    const datepicker = document.getElementById('fecha-de-nacimiento');
    const today = new Date();
    let date = today.getDate() > 9 ? today.getDate() :
      `0${today.getDate()}`;
    let month = today.getMonth() > 9 ? today.getMonth() + 1 :
      `0${today.getMonth() + 1}`;
    let year = today.getFullYear();

    datepicker.setAttribute('max', `${year}-${month}-${date}`);

  }

  getErrorMessage(field: string): string {
    let message;
    const onlyNumbers: Array<string> = ['telefonoFijo', 'telefonoCelular'];
    const required: Array<string> = ['checkBoxDatosPersonales'
    ];
    if (this.isTouchedField(this.naturalForm, field))
    {
      if (this.naturalForm?.get(field).hasError('requiredtrue') || required.includes(field)) {
        message = 'Debe marcar la casilla';
      }
      else if (this.naturalForm?.get(field).hasError('required')) {
        message = 'Es requerido';
      }
      else if (onlyNumbers.includes(field))
      {
        if (this.naturalForm?.get(field).hasError('pattern')) {
          message = `Solo se admiten números`;
        }
        else if (this.naturalForm?.get(field).hasError('minlength')) {
          message = `Debe tener al menos (`+this.naturalForm?.get(field).errors.minlength.requiredLength+`) caracteres`;
        } else if (this.naturalForm?.get(field). hasError('maxlength')) {
          message = `Permite hasta (`+this.naturalForm?.get(field).errors.maxlength.requiredLength+`) caracteres`;
        }
      }
      else if (this.naturalForm?.get(field).hasError('email')) {
        message = 'No tiene el formato de un email';
      }
      else if (this.naturalForm?.get(field).hasError('invalidDate') && this.isTouchedField(this.naturalForm, field)) {
        message = "La fecha no puede ser una fecha futura o superior a la de hoy";
      }
    };

    return message;
  }


}
